import React from "react";
import styles from "./FeaturesStack.module.css";
import { Truck, ShieldCheck, CreditCard, BadgePercent } from "lucide-react";

const FEATURES = [
  {
    id: 1,
    label: "توصيل سريع ومضمون",
    desc: "شبكة توصيل تغطي كل مكان في مصر. كتبك هتوصلك مغلفة بأمان وفوقها ابتسامة.. لأن وقتك ومذاكرتك يهمونا.",
    icon: <Truck size={28} />,
    colorClass: styles.orangeTheme,
  },
  {
    id: 2,
    label: "جودة أصلية 100%",
    desc: "انسى الطباعة الباهتة والورق الخفيف. كل كتاب أو مرجع عندنا أصلي وبأعلى جودة طباعة وخامات تفتح نفسك عالمذاكرة.",
    icon: <ShieldCheck size={28} />,
    colorClass: styles.greenTheme,
  },
  {
    id: 3,
    label: "دفع آمن وسلس",
    desc: "بياناتك في أمان كامل. تقدر تدفع بالطريقة اللي تريحك (كاش عند الاستلام، فيزا، أو محفظة إلكترونية) بكل بساطة.",
    icon: <CreditCard size={28} />,
    colorClass: styles.blueTheme,
  },
  {
    id: 4,
    label: "أقوى العروض والأسعار",
    desc: "بنحطم الأسعار عشان ميزانيتك! خصومات حقيقية ومستمرة على أشمل تشكيلة كتب ومراجع متخصصة في مصر.",
    icon: <BadgePercent size={28} />,
    colorClass: styles.limeTheme,
  },
];

const FeaturesStack = () => {
  return (
    <section className={styles.section} id="features">
      <div className={styles.bgBlob1} />
      <div className={styles.bgBlob2} />

      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>ليه تشتري كتبك مننا؟</h2>
          <p className={styles.subtitle}>
            بنبسطلك التجربة من أول ما تختار كتابك لحد ما يوصل لحد باب بيتك بأفضل
            جودة وسعر.
          </p>
        </div>

        <div className={styles.cardsWrapper}>
          {FEATURES.map((feat) => (
            <div
              key={feat.id}
              className={`${styles.featureCard} ${feat.colorClass}`}
            >
              <div className={styles.shineEffect} />

              <div className={styles.iconBox}>{feat.icon}</div>
              <h3 className={styles.cardTitle}>{feat.label}</h3>
              <p className={styles.cardDesc}>{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesStack;
